import React from "react";
import Gallery from "./Gallery";

function App() {
  return (
    <div className="App">
      <Gallery />
    </div>
  );
}

export default App;
